import React from "react";

const Helpfulresources = () => {
  return (
    <section
      id="helpfulresources"
      className="bg-white text-black scroll-mt-16 py-16 px-6 sm:px-8 lg:px-16 flex flex-col items-center justify-center"
    >
      <h2 className="text-3xl mb-6 sm:mb-6 md:text-3xl md:mb-12  font-bold text-center">
        Helpful Resources
      </h2>

      <div className="max-w-7xl block mx-auto w-full flex flex-col justify-center  space-y-12">
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-6 max-w-6xl mx-auto px-4">
         
            <div className="bg-[#1B3C49] p-6 shadow-md hover:shadow-lg transition ease-out duration-300 rounded-lg">
               {/* <a
            href="/Ethosflo_Guidance_Assessment_Methodology_v1.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
          > */}
              <h3 className="text-2xl font-semibold mb-2 text-white">
              Assessment methodology 
              </h3>
              <p className="text-base md:text-xl text-gray-300">
                Understand how assessments are graded across different ESG
                parameters and what constitutes different maturity levels.
              </p>
              {/* </a> */}
            </div>
          
          
            <div className="bg-[#1B3C49] p-6 shadow-md hover:shadow-lg transition ease-out duration-300 rounded-md">
              <a
            href="/Ethosflo_Guidance_Evidence_Documents_v1.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
          >
              <h3 className="text-2xl font-semibold mb-2 text-white">
                Document Upload Guide
              </h3>
              <p className="text-base md:text-xl text-gray-300">
                Learn best practices for submitting supporting evidence,
                including file formats, size limitations, and documentation
                requirements.
              </p>
              </a>
            </div>
          
          
            <div className="bg-[#1B3C49] p-6 shadow-md hover:shadow-lg transition ease-out duration-300 rounded-md">
             <a
            href="/Ethosflo_Guidance_Assessment_Pillars_v1.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
          >
              <h3 className="text-2xl font-semibold mb-2 text-white pt-1">
                Assessment Pillars
              </h3>
              <p className="text-base md:text-xl text-gray-300 pb-6">
                Explore the key sustainability areas covered in our
                comprehensive assessment framework.
              </p>
              </a>
            </div>
          
        </div>

        {/* <p className="text-xl text-center max-w-4xl px-4">
        Access detailed guidance on assessment pillars, document submission, and scoring methodology to ensure a smooth and informed ESG assessment experience.
        </p> */}
      </div>
    </section>
  );
};

export default Helpfulresources;
